export default "__VITE_ASSET__9a76e1ec__"